module.exports = __webpack_public_path__ + "static/19901c63.partner-ali-logo.png";